import { render } from "./forgetPassword.vue?vue&type=template&id=532ce9d8&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=532ce9d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-532ce9d8"

export default script